import _           from 'underscore';
import * as Stores from './_stores';

const storeResolvers = _.chain( Stores )
                        .values()
                        .map( store => store.resolvers || null )
                        .compact()
                        .value();

export const _resolvers = [ ...storeResolvers ];